import React from 'react'
import { Link } from 'react-router-dom'

const InventoryFaqs = () => {
  return (
   <>
   <div className='container mt-3'  >
      <h2 className=" mb-4" style={{ color: "#73b734" , fontWeight:500,fontSize:"1.4rem"}}>
        Frequently Asked Questions
      </h2>

      <div className="accordion" id="faqAccordion">
        {/* Question 1 */}
        <div className="accordion-item border-0 shadow-sm">
          <h2 className="accordion-header">
            <button
              className="accordion-button fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq1"
              aria-expanded="true"
              aria-controls="faq1"
              style={{ background: "#73b734", color: "#fff" }}
            >
              What happens when I place an order?
            </button>
          </h2>
          <div id="faq1" className="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
            <div className="accordion-body">
              Once the order is placed, our support team contacts you to confirm your availability for the service & an executive is assigned for your order. The executive will reach your location at a preferred time & repair your device.
            </div>
          </div>
        </div>

        {/* Question 2 */}
        <div className="accordion-item border-0 shadow-sm">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq2"
              aria-expanded="false"
              aria-controls="faq2"
              style={{ background: "#73b734", color: "#fff" }}
            >
              How do I pay for my order?
            </button>
          </h2>
          <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body">
              Once the repair is completed by our technician, you can pay using the following methods: Cash, Paytm, UPI, or Credit/Debit Card.
            </div>
          </div>
        </div>

        {/* Question 3 */}
        <div className="accordion-item border-0 shadow-sm">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq3"
              aria-expanded="false"
              aria-controls="faq3"
              style={{ background: "#73b734", color: "#fff" }}
            >
              How Will I Get An Invoice For The Service?
            </button>
          </h2>
          <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body">
              Once the repair order is completed, you will get an email with an invoice in the attachment. The invoice will have the amount charged for the order and can be used later to claim the warranty.
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-4">
        <Link to="/faqs" className="fw-bold" style={{ color: "#73b734" }}>
          Load More FAQs
        </Link>
      </div>
    </div>
   
   </>
  )
}

export default InventoryFaqs